import { getCustomDimension } from 'features/charts-v2/types'
import {
  getDimensionFromOption,
  ISSUE_BREAKDOWN_OPTIONS,
  type IssueBreakdownOption,
  type IssueBreakdownSelectionValue,
} from 'features/trend-detection/utils/dimension-mappings'

export const DEFAULT_BREAKDOWN: IssueBreakdownOption = 'PRODUCT'

export function parseBreakdownSelection(value: IssueBreakdownSelectionValue): {
  dimension: string
  customField?: string
} {
  if (typeof value === 'string' && value.startsWith('custom:')) {
    const [, model, field] = value.split(':')
    if (model && field) {
      const dimension = String(
        getCustomDimension(
          model as 'product' | 'source' | 'post' | 'post_text',
        ),
      )
      return { dimension, customField: field }
    }
  }
  const option = (
    Object.prototype.hasOwnProperty.call(
      ISSUE_BREAKDOWN_OPTIONS,
      value as string,
    )
      ? value
      : DEFAULT_BREAKDOWN
  ) as IssueBreakdownOption
  return { dimension: getDimensionFromOption(option) }
}
